import { Input, InputBase, SegmentedControl } from '@mantine/core'
import { IMaskInput } from 'react-imask'

export type DeliveryMethod = 'electronic' | 'fax' | undefined

export interface DeliveryExtension {
  url: string
  extension?: Array<{
    url: string
    valueBoolean?: boolean
    valueContactPoint?: {
      system: string
      value: string
    }
  }>
}

type DeliveryMethodToggleProps = {
  value: DeliveryMethod
  onChange: (next: DeliveryMethod) => void
  disabled?: boolean
  inputProps?: React.ComponentProps<typeof InputBase>
}

export function DeliveryMethodToggle({
  value,
  onChange,
  disabled,
  inputProps,
}: DeliveryMethodToggleProps) {
  // SegmentedControl works best with string values, so map undefined <-> 'none'
  const uiValue = value ?? 'none'

  return (
    <Input.Wrapper label="Order placement method">
      <SegmentedControl
        fullWidth
        disabled={disabled}
        value={uiValue}
        classNames={{
          root: '!bg-transparent ',
          indicator: '!transition-none',
          control:
            'mx-[1px] ' +
            'border border-gray-300 ' +
            'data-[active]:bg-[#316DAB]/10 ' +
            'data-[active]:text-black ' +
            'data-[active]:border-[#316DAB]',
        }}
        title="Select delivery method"
        onChange={(v) =>
          onChange(v === 'none' ? undefined : (v as Exclude<DeliveryMethod, undefined>))
        }
        data={[
          { label: 'Electronic', value: 'electronic' },
          { label: 'Fax', value: 'fax' },
          { label: 'Not specified', value: 'none' },
        ]}
      />

      {value === 'fax' && (
        <InputBase
          label="Fax number"
          component={IMaskInput}
          placeholder="+1 123 456 7890"
          mask={'+{1} 000 000 0000'}
          disabled={disabled}
          withAsterisk
          {...inputProps}
        />
      )}
    </Input.Wrapper>
  )
}
